import React from "react";

const NavBadge = ({ count = 0, className = "" }) => {
  const safeCount = Number(count || 0);

  if (safeCount <= 0) return null;

  return (
    <span
      className={`absolute -right-1.5 -top-1.5 flex min-h-5 min-w-5 items-center justify-center rounded-full bg-red-600 px-1.5 text-[10px] font-bold leading-none text-white ring-2 ring-white dark:ring-slate-950 ${className}`}
    >
      {safeCount > 99 ? "99+" : safeCount}
    </span>
  );
};

export default NavBadge;